import { Form, Formik } from "formik";
import { useAtom } from "jotai";
import { useLocation, useNavigate } from "react-router-dom";
import { issueAtom } from "./Summary";
import { FormModel } from "../types/FormTypes";
import { formDataAtom } from "../App";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { Box, Heading } from "@ogt/ui";

export default function ThankYou() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const [issue] = useAtom(issueAtom);

  const location = useLocation();
  const emailContact = location.state?.emailContact;

  return (
    <div>
      <Formik<FormModel>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });

          navigate("../fler-resor");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
      >
        {({ values }) => (
          <Form>
            <Box fullwidth>
              <Heading headingRef={h2Ref} focusable>
                Tack för din ansökan!
              </Heading>
              <div role="group">
                <p>
                  Vi har tagit emot din ansökan. Du kommer att få en bekräftelse till mejl: <span className="sans-bold">{emailContact}</span>
                </p>
                <p>
                  Ditt ärendenummer är <strong>{issue?.id ?? ""}</strong>. Uppge det om du kontaktar vår kundservice om det här ärendet.
                </p>

                <Heading as="h3">Vad händer nu?</Heading>

                <p>Din ansökan hanteras av en handläggare.</p>
                <p>
                  Du får svar på om du behöver betala eller inte inom ungefär en månad.
                </p>
                <p>
                  Tänk på att om du överklagar ska du inte betala tilläggsavgiften förrän du fått ett beslut.
                </p>
              </div>
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  );
}
